import logo from 'assets/images/logos/logo.png';

export default function Logo() {
  return <img src={logo} alt="EventHi Logo" width={100} height={100} />;
}
